import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewTag,
  fetchTagRegexes,
  setSelectedTagRegexesSet,
  updateTagRegexesAction,
} from "../../../../redux/reducers/TagRegexes";
import Select from "react-select";
import { ReduxState } from "../../../../redux";
import { flatten, groupBy } from "lodash";
import { Button, Row, Col, Modal, FormControl, InputGroup } from "react-bootstrap";
import {
  deleteTagRegexes,
  deleteTagRegexesSet,
} from "../../../../docuclipper/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getCustomUi } from "../../../Docuclipper/ConfirmAlert/ConfirmAlert";
import { confirmAlert } from "react-confirm-alert";
import TagCards from "./TagCards";
import { TagCategoryRule } from "src/docuclipper/DocuclipperTypes";

export const TagRegexes: React.FC = () => {
  const [existingTag, setExistingTag] = React.useState("");
  const [newTag, setNewTag] = React.useState("");
  const [show, setShow] = React.useState(false);

  const { tagRegexes, tagRegexesSets, selectedTagRegexesSet } =
    useSelector((state: ReduxState) => state.TagRegexes);

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(fetchTagRegexes("categorize"));
  }, []);
  const lsKey = "docuclipper.ui.selectedCategoryGroup";
  React.useEffect(() => {
    const savedSelection = localStorage.getItem(lsKey);
    if (savedSelection) {
      dispatch(setSelectedTagRegexesSet(savedSelection));
    }
  }, []);

  const names = Object.keys(groupBy(tagRegexesSets, "name"));
  const selectedTagIds = !selectedTagRegexesSet
    ? []
    : tagRegexesSets
      .filter((t) => t.name === selectedTagRegexesSet.name)
      .map((x) => x.tagRegexesId);
  const allTagIds = flatten(tagRegexesSets.map((x) => x.tagRegexesId));

  const getTagName = (id) => {
    const matches = tagRegexes.filter((x) => x.id === id);
    if (matches.length > 0) {
      return matches[0].tag;
    }
    return "default";
  };
  const hideStr = (x: string) =>
    x === "c89e2ac11db6184500f0933279a407b3" ? "default" : x;
  const toggle = () => setShow(!show);

  const isDefault = selectedTagRegexesSet
    ? selectedTagRegexesSet.name === "c89e2ac11db6184500f0933279a407b3"
    : false;

  const extractKeywordsFromJsonRules = (jsonRules) => {
    try {
      const rules = JSON.parse(jsonRules);
      return {
        positiveKeywords: rules.conditions.all.find(condition => condition.operator === 'containsAny')?.value.keywords || [],
        negativeKeywords: rules.conditions.all.find(condition => condition.operator === 'doesNotContainAny')?.value.keywords || [],
      };
    } catch (e) {
      console.error('Error parsing jsonRules', e);
      return { positiveKeywords: [], negativeKeywords: [] };
    }
  };

  const handleAddCategory = () => {
    if (newTag.trim() === "") {
      return;
    }

    if (selectedTagRegexesSet) {
      const rule: TagCategoryRule = {
        keywords: [],
        negativeKeywords: [],
        tag: newTag.trim(),
      };
      dispatch(
        addNewTag(
          selectedTagRegexesSet.name,
          newTag.trim(),
          "[]",
          rule
        )
      );
      setNewTag("");
    }
  };

  const handleAddNewKeyword = (tagId: string, keyword: string, isPositive: boolean) => {
    const tag = tagRegexes.find((t) => t.id === tagId);
    if (tag) {
      let positiveKeywords = [];
      let negativeKeywords = [];

      if (tag.jsonRules) {
        const keywords = extractKeywordsFromJsonRules(tag.jsonRules);
        positiveKeywords = keywords.positiveKeywords;
        negativeKeywords = keywords.negativeKeywords;
      } else if (tag.regexes) {
        // Consider regexes as positive keywords if jsonRules is null
        positiveKeywords = JSON.parse(tag.regexes);
      }

      const updatedPositiveKeywords = isPositive ? [...positiveKeywords, keyword] : positiveKeywords;
      const updatedNegativeKeywords = isPositive ? negativeKeywords : [...negativeKeywords, keyword];
      const updatedRule = {
        keywords: updatedPositiveKeywords,
        negativeKeywords: updatedNegativeKeywords,
        tag: tag.tag,
      };

      dispatch(updateTagRegexesAction(tagId, tag.tag, JSON.stringify(updatedRule), updatedRule));
    }
  };

  const onRemoveKeyword = (tagId: string, keyword: string, isPositive: boolean) => {
    const tagToUpdate = tagRegexes.find((t) => t.id === tagId);
    if (tagToUpdate) {
      let positiveKeywords = [];
      let negativeKeywords = [];

      if (tagToUpdate.jsonRules) {
        const keywords = extractKeywordsFromJsonRules(tagToUpdate.jsonRules);
        positiveKeywords = keywords.positiveKeywords;
        negativeKeywords = keywords.negativeKeywords;
      } else if (tagToUpdate.regexes) {
        positiveKeywords = JSON.parse(tagToUpdate.regexes);
      }

      const updatedPositiveKeywords = isPositive ? positiveKeywords.filter((k) => k !== keyword) : positiveKeywords;
      const updatedNegativeKeywords = isPositive ? negativeKeywords : negativeKeywords.filter((k) => k !== keyword);
      const updatedRule = {
        keywords: updatedPositiveKeywords,
        negativeKeywords: updatedNegativeKeywords,
        tag: tagToUpdate.tag,
      };

      dispatch(updateTagRegexesAction(tagId, tagToUpdate.tag, JSON.stringify(updatedRule), updatedRule));
    }
  };


  const onDeleteTag = (id) => {
    deleteTagRegexes(id)
      .then(() => {
        dispatch(fetchTagRegexes("categorize"));
      })
      .catch((err) => null);
  }

  return (
    <div>
      <Row>
        <Col>
          <Select
            options={names.map((x) => ({
              label: hideStr(x),
              value: x,
            }))}
            value={
              selectedTagRegexesSet
                ? {
                  label: hideStr(selectedTagRegexesSet.name),
                  value: selectedTagRegexesSet.id as string,
                }
                : null
            }
            onChange={(value) => {
              if (value) {
                dispatch(setSelectedTagRegexesSet(value.value));
                localStorage.setItem(lsKey, value.value);
              }
            }}
          />
        </Col>

        {!isDefault && (
          <Button
            variant="link"
            onClick={() => {
              confirmAlert({
                customUI: getCustomUi({
                  onConfirm: () => {
                    if (selectedTagRegexesSet) {
                      deleteTagRegexesSet(
                        selectedTagRegexesSet.name,
                        selectedTagRegexesSet.type
                      )
                        .then((rsp) => {
                          dispatch(fetchTagRegexes("categorize"));
                          if (tagRegexesSets.length > 0) {
                            dispatch(
                              setSelectedTagRegexesSet(tagRegexesSets[0].name)
                            );
                          } else {
                            dispatch(setSelectedTagRegexesSet(""));
                          }
                        })
                        .catch((err) => null);
                    }
                  },
                  confirmCTA: "Delete",
                  cancelCTA: "Cancel",
                  getMessage: () => (
                    <div
                      className="div--confirm-job-delete"
                      style={{ marginBottom: "20px" }}
                    >
                      <span>{`Are you sure you want to delete this category group?`}</span>
                    </div>
                  ),
                }),
              });
            }}
          >
            <FontAwesomeIcon icon="trash" />
            <span className="ml-1">Delete</span>
          </Button>
        )}

        <Button variant="link" onClick={toggle}>
          <FontAwesomeIcon icon="cog" />
          <span className="ml-1">Edit Rules</span>
        </Button>

        <Modal size="xl" show={show} onHide={toggle}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Rules</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="4">
                <Row>
                  <Col>
                    <Row>
                      <div className="ml-2" style={{ width: "300px" }}>
                        <Select
                          options={allTagIds
                            .filter((x) => !selectedTagIds.includes(x))
                            .map((x) => ({ label: getTagName(x), value: x }))}
                          value={
                            existingTag
                              ? {
                                label: getTagName(existingTag),
                                value: existingTag,
                              }
                              : null
                          }
                          onChange={(value) => {
                            if (value) {
                              setExistingTag(value.value);
                            }
                          }}
                        />
                      </div>
                      <Button variant="link">
                        <FontAwesomeIcon icon="plus" />
                        <span className="ml-1">
                          {" "}
                          Add Existing Category to Group
                        </span>
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col md="4">
                <Row>
                  <Col>
                    <Row>
                      <InputGroup className="mb-3">
                        <FormControl
                          type="text"
                          placeholder="Enter New Category"
                          value={newTag}
                          onChange={(e) => setNewTag(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              console.log("Enter key pressed -> New Category: ", newTag);
                              handleAddCategory();
                            }
                          }}
                          autoFocus
                        />
                        <InputGroup.Append>
                          <Button
                            variant="primary"
                            onClick={handleAddCategory}
                          >
                            Add New Category
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="h3">Categories</div>
            <TagCards
              tags={tagRegexes.filter((t) => selectedTagIds.includes(t.id)).reverse() as unknown as {
                id: string; tag: string; regexes: string; jsonRules: TagCategoryRule
              }[]}
              onDeleteTag={(id) => onDeleteTag(id)}
              onAddKeyword={(tagId, keyword, isPositive) => handleAddNewKeyword(tagId, keyword, isPositive)}
              onRemoveKeyword={(tagId, keyword, isPositive) => onRemoveKeyword(tagId, keyword, isPositive)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={toggle}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
      <Row className="my-2 mx-1">
        <Col className="text-truncate" style={{ maxWidth: "800px" }}>
          <span className="font-weight-bold">Categories:</span>
          <span className="ml-2">{`${selectedTagIds
            .map((t) => getTagName(t))
            .join(",")}`}</span>
        </Col>
      </Row>
    </div>
  );
};
export default TagRegexes;
